import { MapStateToPropsFactory } from "react-redux";
import { getIsBetslipLoaded } from "../../store/state/betslip-module/betslip-module-selectors";
import { BetslipApplicationState } from "../../store/state/BetslipApplicationState";
import { BettingState } from "@ppb/betslip-core";

import { createGetMultipleCombinations } from "../SportsbookPlace/sportsbook-place-mapper";
import { createIsConfirmStep, createGetConfirmationMultipleCombinations } from "../sportsbook-betslip-confirm-mapper";

type CardProps = {
  multiples: BettingState.Combination[];
};

export type StateProps = CardProps | Record<string, never>;

export type ContainerProps = {
  shouldRenderBetLegs?: boolean;
  shouldFocusStakeField?: boolean;
};

export const makeMapStateToProps: MapStateToPropsFactory<StateProps, ContainerProps, BetslipApplicationState> = () => {
  const getMultipleCombinations = createGetMultipleCombinations();
  const getConfirmMultipleCombinations = createGetConfirmationMultipleCombinations();
  const getIsConfirmStep = createIsConfirmStep();
  return (appState: BetslipApplicationState): StateProps => {
    const isBetslipLoaded = getIsBetslipLoaded(appState);
    const isConfirmStep = getIsConfirmStep(appState);

    const multipleCombinations = isConfirmStep
      ? getConfirmMultipleCombinations(appState)
      : getMultipleCombinations(appState);

    if (!isBetslipLoaded || !multipleCombinations?.multiLinesCombinations.length) {
      return {};
    }

    return {
      multiples: multipleCombinations.multiLinesCombinations,
    };
  };
};
